import { CommandBar, DefaultButton, DocumentCard, DocumentCardDetails, DocumentCardPreview, DocumentCardTitle, DocumentCardType, getFocusStyle, getTheme, IButtonProps, ICommandBarItemProps, ICommandBarStyles, Icon, IDocumentCardPreviewProps, IDocumentCardStyles, IDropdownOption, IPanelStyles, ITheme, List, mergeStyleSets, MessageBar, MessageBarType, Panel, PanelType, PrimaryButton } from '@fluentui/react';
import { getFileTypeIconProps } from '@fluentui/react-file-type-icons';
import { useBoolean } from '@fluentui/react-hooks';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import { store } from '../../../..';
import { myTheme } from '../../../../assets/styles/my-theme';
import protocolsService from '../../../../services/protocols.service';
import { IDestinatarioPecMail, IField, ISendMailFields } from '../../../../shared/interfaces';
import AppUtilities from '../../../../shared/Utilities/appUtilities';
import { reduxActions, RootState } from '../../../../store';
import CustomCommandBarButton from '../../../CustomFluentUI/CustomCommandBarButton/CustomCommandBarButton';
import CustomCommandBarMenuItem from '../../../CustomFluentUI/CustomCommandBarMenuItem/CustomCommandBarMenuItem';
import IndicePAPanel from '../../../IndicePA/IndicePAPanel';
import RubricaPanel from '../../../Rubrica/RubricaPanel';
import SendMailForm from './SendMailForm';
import abilityBuild from '../../../../shared/CASL/appAbility';
import { subject } from "@casl/ability";


const queryString = require('query-string');

const panelStyles: Partial<IPanelStyles> = {
    content: {
        padding: '24px 20px 0px',
        display: 'flex',
        flexFlow: 'column',
        overflow: 'hidden',
    },
    scrollableContent: {
        display: 'flex',
        flexFlow: 'column',
        overflow: 'hidden',

    }
}

const documentCardSyles: Partial<IDocumentCardStyles> = {
    root: {
        height: 65,
        maxWidth: 'unset !important'
    }
}

const overflowProps: IButtonProps = {
    menuProps: {
        contextualMenuItemAs: CustomCommandBarMenuItem,
        items: []
    },
};

const commandBarStyles: Partial<ICommandBarStyles> = {
    root: { padding: '0 24px', borderBottom: '1px solid #eee', borderTop: '1px solid #eee' },
    secondarySet: {
        '& .ms-OverflowSet-item': {
            display: 'flex', flexFlow: 'row', justifyContent: 'center', padding: '4px'
        }
    }
};

const theme: ITheme = getTheme();
const { semanticColors, fonts } = theme;
const { palette } = myTheme;

const classNames = mergeStyleSets({
    itemCell: [
        getFocusStyle(theme, { inset: -1 }),
        {
            minHeight: 54,
            padding: 10,
            boxSizing: 'border-box',
            borderBottom: `1px solid ${semanticColors.bodyDivider}`,
            display: 'flex',
            selectors: {
                '&:hover': { background: palette.neutralLight },
            },
        },
    ],
    itemImage: {
        flexShrink: 0,
    },
    itemContent: {
        marginLeft: 10,
        overflow: 'hidden',
        flexGrow: 1,
    },
    itemName: [
        fonts.medium,
        {
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
    ],
    itemDimension: {
        fontSize: fonts.small.fontSize,
        color: palette.neutralTertiary,
        marginBottom: 10,
        padding: '0px 16px'
    },
    chevron: {
        alignSelf: 'center',
        marginLeft: 10,
        color: palette.neutralTertiary,
        fontSize: fonts.large.fontSize,
        flexShrink: 0,
    },
});
let initialSendMailFields: ISendMailFields = {
    from: {
        displayName: "Da",
        internalName: "from",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false,
        options: [],
        multi: false

    },
    to: {
        displayName: "A",
        internalName: "to",
        sharepointType: "Text",
        controlType: "autocomplete",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: [],
        valid: false,
        touched: false
    },
    cc: {
        displayName: "CC",
        internalName: "cc",
        sharepointType: "Text",
        controlType: "autocomplete",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: [],
        valid: false,
        touched: false
    },
    subject: {
        displayName: "Oggetto",
        internalName: "subject",
        sharepointType: "Text",
        controlType: "textbox",
        required: true,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    },
    body: {
        displayName: "Corpo",
        internalName: "body",
        sharepointType: "Text",
        controlType: "quill-editor",
        required: false,
        readonly: false,
        disabled: false,
        system: false,
        internalValue: "",
        valid: false,
        touched: false
    }
}

export interface SendMailPanelProps {
    loading?: boolean
    extraCssClass?: string
    sendMailPanelIsOpen: boolean
    mailboxes: string[] | undefined
    onSendMail: (mail) => void
    onDismiss: () => void


}
type Props = SendMailPanelProps & RouteComponentProps

const SendMailPanel: React.FunctionComponent<Props> = (props) => {

    let loading = props.loading !== undefined ? props.loading : false;

    let [panelIsOpen, { setTrue: openSendMailPanel, setFalse: dismissSendMailPanel }] = useBoolean(props.sendMailPanelIsOpen);
    let [sendMailFields, setSendMailFields] = useState<ISendMailFields>(initialSendMailFields)
    let [mailAttachments, setMailAttachments] = useState<any[]>([]);

    let [messageBarIsVisible, { setTrue: showMessageBar, setFalse: dismissMessageBar }] = useBoolean(false);

    let [messageBarType, setMessageBarType] = useState<MessageBarType>(MessageBarType.info)
    let [messageBarText, setMessageBarText] = useState<string>('')

    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectCurrentProtocol = (state: RootState) => state.appNavigationReducer.protocol
    const currentProtocol = useSelector(selectCurrentProtocol);

    const [indicePAPanelIsOpen, { setTrue: showIndicePAPanel, setFalse: closeIndicePAPanel }] = useBoolean(false);
    const [rubricaPanelIsOpen, { setTrue: showRubricaPanel, setFalse: closeRubricaPanel }] = useBoolean(false);

    const [commandBarItems, setCommandBarItems] = useState<ICommandBarItemProps[]>([]);
    const attachmentsGetBase64Requests = {};


    useEffect(() => {
        if (currentProtocol && currentAoo) {

            let newSendMailFields = { ...sendMailFields };

            let oggettoProtocollo = currentProtocol.fields?.find(el => el.internalName === 'OggettoProtocollo');
            newSendMailFields.subject.internalValue = AppUtilities.FormatProtocolNumber(currentProtocol);
            if (oggettoProtocollo && oggettoProtocollo.internalValue) {
                newSendMailFields.subject.internalValue += " - " + oggettoProtocollo.internalValue;
            }
            setSendMailFields(newSendMailFields);
            let { docBase64String, ...documentNoBase64 } = currentProtocol.documentFile!;
            let newMailAttachments: any[] = [{
                nomeFile: currentProtocol.documentFile?.fileName,
                buff: currentProtocol.documentFile?.docBase64String,
                ...documentNoBase64!
            }];
            const parsedQueryString = queryString.parse(props.location.search);

            currentProtocol.attachments?.forEach((el, index) => {
                let { docBase64String, ...attachmentNoBase64 } = el;
                let fileName = el.originalName ? el.originalName : el.fileName;

                newMailAttachments.push({
                    nomeFile: fileName,
                    buff: el.docBase64String,
                    loading: true,
                    ...attachmentNoBase64
                })
                let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

                if (uorId && !el.docBase64String) {
                    attachmentsGetBase64Requests[index] = protocolsService.getFileSPById(currentAoo.id, uorId, props.match.params['id'], el.id!);

                }
            });
            setMailAttachments(newMailAttachments);

            let reqArray = Object.values(attachmentsGetBase64Requests);
            if (reqArray && reqArray.length > 0) {
                axios.all(reqArray).then(axios.spread((...responses) => {
                    let protocolAttachments = currentProtocol.attachments ? [...currentProtocol.attachments] : [];

                    responses.forEach((fileResult: any) => {
                        let attachmentIndex = protocolAttachments.findIndex(el => el.fileName === fileResult.fileName);
                        if (attachmentIndex >= 0) {
                            let attachment = {
                                ...protocolAttachments[attachmentIndex],
                                docBase64String: fileResult.docBase64String,
                                loading: false

                            }
                            protocolAttachments[attachmentIndex] = attachment;

                        }
                    });

                    store.dispatch(reduxActions.appNavigationActions.setProtocol({ attachments: protocolAttachments }));

                }));
            }

        }
    }, [currentProtocol]);



    useEffect(() => {
        if (props.sendMailPanelIsOpen)
            openSendMailPanel();
        else
            dismissSendMailPanel();

    }, [props.sendMailPanelIsOpen]);

    useEffect(() => {
        let newSendMailFields = { ...sendMailFields };

        let options: IDropdownOption[] = [];
        if (props.mailboxes) {
            dismissMessageBar();

            props.mailboxes.forEach(el => {
                if (el) {
                    options.push({ key: el, text: el });
                }
            });
        }
        else {
            setMessageBarText("Nessuna cassetta configurata");
            setMessageBarType(MessageBarType.error)
            showMessageBar();

        }
        if (options.length == 1) {
            newSendMailFields.from = {
                ...newSendMailFields.from,
                options: options,
                internalValue: options[0].text,
            }
        }
        else if (options.length > 1) {
            newSendMailFields.from = { ...newSendMailFields.from, options: options }

        }
        setSendMailFields(newSendMailFields);



    }, [props.mailboxes]);


    useEffect(() => {
        setCommandBar()
    }, [abilityBuild])

    const setCommandBar = () => {
        let newCommandBarItems: ICommandBarItemProps[] = [];

        newCommandBarItems.push({
            key: 'indicePA',
            commandBarButtonAs: () => (

                <CustomCommandBarButton
                    text='Indice PA'
                    key='indicePA'
                    iconPropsFontAwesome={{ icon: ['far', 'filter'] }}
                    onClick={() => showIndicePAPanel()}
                />

            )
        });

        if (abilityBuild.can('use', subject('IFeature', { key: 'Rubrica', enabled: true }))) {
            newCommandBarItems.push({
                key: 'rubrica',
                commandBarButtonAs: () => (
                    <CustomCommandBarButton
                        text='Rubrica'
                        key='rubrica'
                        iconPropsFontAwesome={{ icon: ['fal', 'address-book'] }}
                        onClick={() => showRubricaPanel()}
                    />
                )

            });
        }
        setCommandBarItems(newCommandBarItems);

    }


    const inputChangedHandler = (newField: IField) => {

        const updatedFields = { ...sendMailFields };
        updatedFields[newField.internalName] = { ...newField };

        setSendMailFields(updatedFields);
    }




    const checkFormValidity = (): boolean => {
        let isValid = true;

        let errors = {};

        let newSendMailFields = { ...sendMailFields };



        Object.values(sendMailFields).forEach((field: IField, index) => {
            let newField = { ...field };
            let fieldValidity = AppUtilities.checkFieldValidity(newField)
            if (!fieldValidity) {
                isValid = false;
                errors["fields"] = "compilare correttamente tutti i campi obbligatori";
            }
            newSendMailFields[newField.internalName] = {
                ...newField,
                touched: true,
                valid: fieldValidity
            }

        });
        if (mailAttachments.some(el => el.loading)) {
            isValid = false;
            errors["attachments"] = "attendere il caricamento degli allegati";
        }

        setSendMailFields(newSendMailFields);

        if (isValid)
            dismissMessageBar()
        else {
            let errorMessage = AppUtilities.getMessageFromErrorObjectValidity(errors);
            setMessageBarText(errorMessage);
            setMessageBarType(MessageBarType.error)
            showMessageBar();

        }
        return isValid;
    }


    const sendMailPanelSubmit = () => {
        if (checkFormValidity()) {
            let destinatari: IDestinatarioPecMail[] = sendMailFields.to.internalValue
                .map(el => {
                    let dest: Partial<IDestinatarioPecMail> = {
                        email: el.key,
                    }
                    return dest;
                });
            let cc: IDestinatarioPecMail[] = sendMailFields.cc.internalValue
                .map(el => {
                    let dest: Partial<IDestinatarioPecMail> = {
                        email: el.key,
                    }
                    return dest;
                });

            //let cc: string[] = [];
            //if (sendMailFields.cc.internalValue) {
            //    sendMailFields.cc.internalValue.fore(el => { return el.name });
            //}
            let mail = {
                from: sendMailFields.from.internalValue,
                to: [...destinatari],
                cc: [...cc],
                allegati: mailAttachments,
                subject: sendMailFields.subject.internalValue,
                body: sendMailFields.body.internalValue,


            };

            props.onSendMail(mail);
            resetFormFields();
        }

    }

    const sendMailPanelDismiss = () => {


        props.onDismiss();
    }


    const resetFormFields = () => {
        let newSendMailFields = { ...sendMailFields };

        Object.values(sendMailFields).forEach((field: IField, index) => {
            let newField = { ...field, internalValue: null, touched: false, valid: true };

            newSendMailFields[newField.internalName] = { ...newField };
        });

        setSendMailFields(newSendMailFields);
    }

    const previewPropsUsingIcon: IDocumentCardPreviewProps = {
        previewImages: [
            {
                previewIconProps: {
                    iconName: 'OpenFile',
                    styles: {
                        root: {
                            fontSize: fonts.large.fontSize,
                            color: palette.themePrimary,
                            backgroundColor: palette.neutralLighterAlt,
                        },
                    },
                },
                width: 63,
            }
        ],
        styles: {
            previewIcon: { backgroundColor: palette.neutralLighterAlt },
        },
    };


    const dismissIncicePALateralPanel = () => {
        closeIndicePAPanel();
    }

    const dismissRubricaLateralPanel = () => {
        closeRubricaPanel();
    }



    const attachmentRenderIcon = (item) => {
        if (item.loading) {
            return <div style={{ fontSize: 20 }}> <FontAwesomeIcon icon={['fal', 'circle-notch']} spin /></div>;
        }
        else
            return <Icon {...getFileTypeIconProps({ extension: item.extension, size: 20 })} />;

    }

    const attachmentRenderCell = (item) => {
        const previewPropsUsingIcon: IDocumentCardPreviewProps = {
            previewImages: [
                {
                    previewIconProps: {
                        children: attachmentRenderIcon(item)
                    },
                    width: 63,

                }
            ],
            styles: {
                previewIcon: { backgroundColor: palette.neutralLighterAlt },
            },

        };
        let fileName = item.originalName ? item.originalName : item.fileName;

        return (
            <DocumentCard
                aria-label={fileName}
                type={DocumentCardType.compact}
                styles={documentCardSyles}
            >
                <DocumentCardPreview {...previewPropsUsingIcon} />
                <DocumentCardDetails>
                    <DocumentCardTitle title={fileName} className={classNames.itemName} />
                    <div className={classNames.itemDimension}>{AppUtilities.GetDimensionFileString(item)}</div>
                </DocumentCardDetails>
                {/*<DocumentCardActions*/}
                {/*    actions={[*/}
                {/*        {*/}
                {/*            iconProps: { iconName: 'Delete' },*/}
                {/*            onClick: (ev) => onRemoveFileItemClick(ev, item),*/}
                {/*            ariaLabel: 'Elimina',*/}
                {/*        }*/}
                {/*    ]} />*/}

            </DocumentCard>
        );
    }


    const onRenderFooterContent = () => {
        return (
            <React.Fragment>
                <PrimaryButton
                    styles={{ root: { marginRight: 8 } }}
                    text="Invia"
                    onClick={sendMailPanelSubmit}

                />
                <DefaultButton
                    onClick={sendMailPanelDismiss}
                    text="Annulla"
                />
            </React.Fragment>
        );
    }

    return (
        <Panel
            key='sendMailPanel'

            isLightDismiss
            isOpen={panelIsOpen}
            type={PanelType.custom}
            customWidth={'750px'}
            styles={panelStyles}
            headerText="Spedizione protocollo"
            focusTrapZoneProps={{
                isClickableOutsideFocusTrap: true,
                forceFocusInsideTrap: true,
            }}
            onDismiss={sendMailPanelDismiss}
            onRenderFooterContent={onRenderFooterContent}
            // Stretch panel content to fill the available height so the footer is positioned
            // at the bottom of the page
            isFooterAtBottom={false}

        >
            {
                messageBarIsVisible &&
                <MessageBar
                    messageBarType={messageBarType}
                    isMultiline={false}
                    onDismiss={dismissMessageBar}
                    dismissButtonAriaLabel="Close">{messageBarText}</MessageBar>
            }

            <div className={"flex flex-column position-relative overflow-hidden"}>
                <CommandBar
                    overflowButtonProps={overflowProps}
                    items={commandBarItems}
                    styles={commandBarStyles}

                />

                <div className={`position-relative my-scroll-div`}>
                    <SendMailForm
                        sendMailFields={sendMailFields}
                        onInputChangedHandler={(newField) => { inputChangedHandler(newField) }}
                    />
                    <List items={mailAttachments} onRenderCell={attachmentRenderCell} style={{ paddingTop: '50px' }} />
                </div>
            </div>

            {indicePAPanelIsOpen &&
                <IndicePAPanel
                    indicePAPanelIsOpen={indicePAPanelIsOpen}
                    onIndicePADismiss={dismissIncicePALateralPanel}
                    {...props}
                />
            }

            {rubricaPanelIsOpen &&
                <RubricaPanel
                    rubricaPanelIsOpen={rubricaPanelIsOpen}
                    onRubricaDismiss={dismissRubricaLateralPanel}
                    {...props}
                />
            }

        </Panel>

    );
};


export default SendMailPanel;



